<template>
  <v-app id="improve" :class="[$globalConfig.APP_NAME == 'senso' ? 'edify' : 'improve']">
    <router-view />
    <vue-snotify></vue-snotify>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
      timeoutID: ''
    }
  },
  methods: {
    // setup() {
    //   document.addEventListener("mousemove", this.resetTimer, false);
    //   document.addEventListener("mousedown", this.resetTimer, false);
    //   document.addEventListener("keypress", this.resetTimer, false);
    //   document.addEventListener("DOMMouseScroll", this.resetTimer, false);
    //   document.addEventListener("mousewheel", this.resetTimer, false);
    //   document.addEventListener("touchmove", this.resetTimer, false);
    //   document.addEventListener("MSPointerMove", this.resetTimer, false);
    // },
    // startTimer() {
    //   this.timeoutID = window.setTimeout(this.goInactive, 1200000);
    // },
    // resetTimer() {
    //   window.clearTimeout(this.timeoutID);
    //   this.goActive();
    // },
    // goInactive() {
    //   this.$store.dispatch("logout").then(() => {
    //     var elem = document.getElementById("freshchat-js-sdk");
    //     if (elem) {
    //       elem.parentNode.removeChild(elem);
    //       this.$router.push("/login");
    //     } else {
    //       this.$router.push("/login");
    //     }
    //   });
    // },
    // goActive() {
    //   this.startTimer();
    // }
  },
  created () {
    // this.setup()
  }
};
</script>
